import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ActivityTagLabelPipe } from './activity-tag-label.pipe';

@NgModule({
  declarations: [ActivityTagLabelPipe],
  imports: [CommonModule],
  exports: [ActivityTagLabelPipe],
})
export class ActivityTagsModule {}
